import React, { Component } from "react";
import "./VideoUpload.css";
const VideoUploadUrl = "https://videosforchange.wetransfer.com/?to=entries@highresolves.org";

export default class VideoUpload extends Component {
  render() {
    const { disabled } = this.props;

    return disabled
      ? (<div
        className="button -primary"
        disabled={disabled}
      >
        Upload my files
        <i className="icon-open"></i>
      </div>)
      : (<a
          href={VideoUploadUrl}
          className="button -primary"
          target="_blank"
          disabled={disabled}
        >
          Upload my files
          <i className="icon-open"></i>
        </a>)
  }
}



// WEBPACK FOOTER //
// ./src/components/VideoUpload/VideoUpload.js